import { useTranslation } from 'react-i18next';
import { Text, Button, Stack } from '@hotjar/hotsauce';

export interface GTMVerifyProps {
  onClick: () => void;
  onCancel: () => void;
  isCancelVisible?: boolean;
}

export const GTMVerify = ({ onClick, onCancel, isCancelVisible }: GTMVerifyProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack direction="column">
      <Text>{t('activation:gtm-verify.text')}</Text>
      <Stack>
        <Button kind="primary" onClick={onClick}>
          {t('activation:gtm-verify.cta')}
        </Button>
        {isCancelVisible ? (
          <Button kind="ghost" onClick={onCancel}>
            {t('activation:gtm-verify.cancel')}
          </Button>
        ) : null}
      </Stack>
    </Stack>
  );
};
